import react from "../../../assets/img/programming/react.webp";
import angular from "../../../assets/img/programming/angular.webp";
import vue from "../../../assets/img/programming/vue.webp";
// import svelte from "../../../assets/img/programming/svelte.webp";
// import django from "../../../assets/img/programming/django.webp";
// import ruby from "../../assets/img/programming/ruby.webp";
// import cplus from "../../assets/img/programming/cplus.webp";
// import csharp from "../../assets/img/programming/csharp.webp";
// import go from "../../assets/img/programming/go.webp";

export const DataFramework = [
  {
    title: "React",
    path: "/programming/react",
    icon: react,
    cName: "icon",
    description:
      "React JS is an open-source, component-based Javascript library, which is used to build UI specifically for single-page applications. It’s one of the most popular Javascript libraries used to build apps front-end right now. ",
  },
  {
    title: "Angular",
    path: "/programming/angular",
    icon: angular,
    cName: "icon",
    description:
      "Angular is a platform and framework for building client-side web and mobile applications using HTML & Javascript.Angular is written in Typescript which imports functionalities as typescript libraries.",
  },
  {
    title: "Vue",
    path: "/programming/vue",
    icon: vue,
    cName: "icon",
    description:
      "Vue is a progressive framework for building user interfaces. Unlike other monolithic frameworks, Vue is designed from the ground up to be incrementally adoptable. The core library is focused on the view layer only, and is easy to pick up and integrate with other libraries or existing projects. ",
  },
  // {
  //   title: "Svelte",
  //   path: "/programming/svelte",
  //   icon: svelte,
  //   cName: "icon",
  // description:
  //     "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",  //

  // {
  //   title: "Django",
  //   path: "/programming/django",
  //   icon: django,
  //   cName: "icon",
  //   description:
  //       "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",  //
  // },
  // {
  //   title: "Ruby",
  //   path: "/programming/ruby",
  //   icon: ruby,
  //   cName: "icon",
  //   description:
  //       "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",  //
  // },
  // {
  //   title: "C++",
  //   path: "/programming/c-plus-plus",
  //   icon: cplus,
  //   cName: "icon",
  //   description:
  //       "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",  //
  // },
  // {
  //   title: "C#",
  //   path: "/programming/c-sharp",
  //   icon: csharp,
  //   cName: "icon",
  //   description:
  //       "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",  //
  // },
  // {
  //   title: "Go",
  //   path: "/programming/go",
  //   icon: go,
  //   cName: "icon",
  //   description:
  //       "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",  //
  // },
];
